import UIPhoneInput from './Component';

export default UIPhoneInput;